module.exports = __webpack_public_path__ + "static/img/jczu.c5dbc9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/company/jczu.png
// module id = jcvX
// module chunks = 3